import data from './emoji-data.js'

const types = Object.keys(data)
const keys = []
const mapper = {}

types.forEach(type => {
    const typeObj = data[type]
    Object.keys(typeObj).forEach(key => {
        keys.push(key)
        mapper[key] = typeObj[key]
    })
})

export function parseString(str) {
    const result = []
    const arr = str.replace(/:[a-zA-Z]+:/g, '\\$&\\').split('\\')
    arr.forEach(tuple => {
        if (tuple.length === 0) {
            return
        }
        const obj = { content: tuple }
        if (keys.includes(tuple)) {
            obj.isEmoji = true
            obj.cls = `emoji-item sprite-${tuple.replace(/:/g, '')}`
        } else {
            obj.isEmoji = false
            obj.cls = ''
        }
        result.push(obj)
    })
    return result
}
